import { MemoryService } from "../../memoryService";

export const textValuesFromCurrentAnswer = (service: MemoryService | undefined) => 
    service?.getCurrentAnswer()?.values?.map(val => val.value);
